<template>
    <div>
        <div class="maindiv" v-if="isMobile">
            <div class="right-portionmobile">
                <div class="rightHeader">
                    <p class="right-header-text">Farmstock Technologies</p>
                    <p class="right-subheader-text">A one-stop solution for all your agricultural
                        needs with the aim of digitalizing agriculture in India</p>

                </div>
                <div class="contactMaindivmobile">
                    <div class="addressdivmobile">
                        <div class="addressIcondiv">
                            <img width="59" height="59"
                             src="../../../assets/FrontPage/AddressIcon.png" />
                        </div>
                        <div class="addressTextdiv ">
                            <p class="addressText">
                                5th Floor, Plot No. 79, Sector 44, Gurugram, Haryana,
                                122003
                            </p>
                        </div>
                    </div>
                </div>
                <div class="iconsdivmobile">
                    <a href="https://www.linkedin.com/company/krishifyapp/mycompany/" target="blank">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/linkedin.png" alt="">
                        </a>
                        <a href="https://www.youtube.com/channel/UCnnFUoeBh7J7j64cOD4Z26g" target="blank">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/youtube.png" alt="">
                        </a>
                        <a target="blank" href="https://www.facebook.com/krishify/">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/facebook.png" alt="">
                        </a>
                        <a target="blank" href="https://www.instagram.com/krishifyapp/">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/instagram.png" alt="">
                        </a>
                       
                        <a href="https://twitter.com/krishifyapp" target="blank">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/twitter.png" alt="">
                        </a>
                   

                </div>
                <div class="copyrightDiv">
                    <p class="copyrightText"> Copyright © {{ currentYear }} Krishify</p>
                </div>
            </div>
        </div>
        <div class="maindivdesktop" v-else>


            <div class="left-portion">
                <div class="leftHeader">
                    <p class="left-header-text">Find us on Social Media</p>
                    <div class="iconsdiv">
                        <a href="https://www.linkedin.com/company/krishifyapp/mycompany/" target="blank">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/linkedin.png" alt="">
                        </a>
                        <a href="https://www.youtube.com/channel/UCnnFUoeBh7J7j64cOD4Z26g" target="blank">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/youtube.png" alt="">
                        </a>
                        <a target="blank" href="https://www.facebook.com/krishify/">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/facebook.png" alt="">
                        </a>
                        <a target="blank" href="https://www.instagram.com/krishifyapp/">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/instagram.png" alt="">
                        </a>
                       
                        <a href="https://twitter.com/krishifyapp" target="blank">
                            <img class="socialmediaicons"
                                src="../../../assets/LandingPage/footerIcons/twitter.png" alt="">
                        </a>
                        

                    </div>
                    <div class="copyrightDiv">
                        <p class="copyrightText"> Copyright © {{ currentYear }} Krishify</p>
                    </div>
                </div>



            </div>
            <div class="right-portion">
                <div class="rightHeader">
                    <p class="right-header-text">Farmstock Technologies</p>
                    <p class="right-subheader-text">A one-stop solution for all your agricultural
                        needs with the aim of digitalizing agriculture in India</p>

                </div>
                <div class="contactMaindiv">
                    <div class="addressdiv">
                        <div class="addressIcondiv">
                            <img  width="59" height="59"
                                src="../../../assets/FrontPage/AddressIcon.png" />
                        </div>
                        <div class="addressTextdiv">
                            <p class="addressText">
                               Basement, Landmark Tower, Plot No.2, Southcity-1, Opposite C-113, Ashok Marg, Sector 41, Gurgaon - 122001
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    name: "LandingPagefooter",
    data() {
        return {
            isMobile: false,
        };
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    },
    methods: {
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
    },
    mounted() {
        this.checkDevices();
    },
}
</script>


</script>
<style lang="scss" scoped>
.maindiv {
    width: 100%;
    display: flex;
    background: #FAF9F3;
    padding-top: 20px;


}

.maindivdesktop {
    width: 100%;
    display: flex;
    background: #FAF9F3;
    padding-top: 60px;
}

.left-portion {
    width: 52%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.iconsdiv {
    margin-bottom: 20px;
    display: flex;
    gap: 26px;
    align-items: flex-start;

    flex-wrap: wrap;

}

.iconsdivmobile{
    margin-bottom: 20px;
    display: flex;
    gap: 20px;
    align-items: flex-start;

    flex-wrap: wrap;
}

.copyrightText {
    font-weight: 400;
    font-size: 16px;
    line-height: 27px;
    /* identical to box height, or 169% */


    /* Light Grey */

    color: #797E79;
}

.right-portion {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.right-portionmobile{
    width: 82%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
 
    margin:0px auto ;
  

}

.rightHeader {
    margin-bottom: 10px;
}

.contactMaindiv {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
}
.contactMaindivmobile{
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
}
.leftHeader {
    display: flex;
    flex-direction: column;
}

.left-header-text {
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    /* identical to div height, or 125% */

    display: flex;
    align-items: center;

    /* Grey */

    color: #3A3F3A;

}

.right-header-text {
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    /* identical to div height, or 125% */

    display: flex;
    align-items: center;

    /* Grey */

    color: #3A3F3A;
}

.right-subheader-text {
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    /* or 150% */
width: 80%;

    /* Light Grey */

    color: #797E79;
}

.addressBox {
    display: flex;
    align-items: center;

    padding-bottom: 16px;

}

.addressdiv {
    display: flex;
    margin-bottom: 5px;
}
.addressdivmobile{
    display: flex;
    margin-bottom: 5px;
}

.addressIcondiv {
    width: 15%;
   
    margin-bottom: 5px;
   
    display: flex;
    justify-content: start;
    align-items: center;
}

.addressTextdiv {
    width: 100%;
    display: flex;
    cursor: pointer;
    align-items: center;
}


.addressText {
    margin-bottom: 0px;
    display: flex;
    font-size: 18px;
    line-height: 27px;
    /* or 150% */
    width: 97%;
margin-left: 5px;
    /* Primary */

    color: #3A3F3A;

}

.contactTextDiv {
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}






@media all and (max-width: 1024px) {
    .maindiv {
        flex-direction: column;

    }
}

@media all and (max-width: 1024px) {
    .left-portion {
        align-items: flex-start;
        width: 100%;
    }

}

@media all and (max-width: 1024px) {
    .right-portion {
        width: 100%;
    }

}

@media all and (max-width: 1024px) {
    .maindiv {
        padding-left: 10px;
    }

}

@media all and (max-width: 1024px) {
    .iconsdiv {
        width: 100%;
    }

}
@media all and (max-width: 1024px) {
    .addressTextdiv {
        width: 100%;
    }

}
@media all and (max-width: 1024px) {
    .addressIcondiv {
        width: 20%;
    }

}



@media all and (max-width: 1024px) {
    .socialmediaicons {
        width: 45px;
        height: 45px;
    }

}
@media all and (max-width: 1024px) {
    .right-subheader-text
 {
        width: 90%;
      
    }

}
</style>
